import UserSectionMenu from "../../components/UserSectionMenu";
import AddUserForm from "./AddUserForm";
import UserInformation from "../../components/UserInformation";
import {useEffect, useState} from "react";
import PasswordChangeBox from "../../components/PasswordChangeBox";
import {MyContext} from "../../context/myContext";
import AddUserBox from "../../components/AddUserBox";
import {PersianToEnglish} from "numeral-convert";
import {useDispatch, useSelector} from "react-redux";
import {getUsers, handleShowUserPasswordForm, postUserPasswordForm, selectSelectedUser, selectShowUserPasswordForm, selectUsersBodyArray, setUserInfo} from "./userSlice";
import {callApiAgain, selectCallApi, selectShowEditForm, selectShowForm, showPopUp} from "../common-states/commonStatesSlice";
import {handleShowPopUp} from "../common-states/handleShowPopUp";

const data = [
    {id: 'username', name: 'username', label: 'نام کاربر'},
    {id: 'icon1', name: 'newPass', label: 'رمز عبور جدید'},
    {id: 'icon2', name: 'repeatNewPass', label: 'تکرار رمز عبور'},
]

const UsersManagement = () => {
    const initialPasswords = {username: 'username', newPass: '', repeatNewPass: ''}
    const initialShowPass = {username: true, icon1: false, icon2: false}
    const headArray = ['حذف', 'تغییر رمز', 'ویرایش', 'شهر پیش فرض', 'شماره تماس', 'نام کاربری', 'نام و نام خانوادگی', 'ردیف',];
    const initialState = { addedCities: [], selectedCity: 0, error: {showExtraCityError: false, showNoneExistCities: false }}
    const initialInputState = {
        tel: '', name: '', password: '', username: '', province: 'خراسان جنوبی', level: '',
        checked: ['delNomad','editNomad','addNomad','delDriver','editDriver','addDriver','rejectReq','manualDeliver',
            'addWaterReq','getExcel','seeingReport','delReq',]
    }
    const [searchedBodyArray, setSearchedBodyArray] = useState([])
    const [selectedUser, setSelectedUser] = useState({userName: '', userId: null})
    const [userId, setUserId] = useState('')
    const [editState, setEditState] = useState(initialState)
    const [editFormikValues, setEditFormikValues] = useState(initialInputState)
    const dispatch = useDispatch()
    const callApi = useSelector(selectCallApi)
    const bodyArray = useSelector(selectUsersBodyArray)
    const selectedUserFromStore = useSelector(selectSelectedUser)
    const showForm = useSelector(selectShowForm)
    const showEditForm = useSelector(selectShowEditForm)
    const showUserPasswordForm = useSelector(selectShowUserPasswordForm)

    const handleShowPasswordForm = (item) => {
        dispatch(handleShowUserPasswordForm(!showUserPasswordForm))
        setSelectedUser({userName: item.username, userId: item.user_id})
    }
    const handleShowEditForm = (item) => {
        setUserId(item.user_id)
        dispatch(showPopUp({type: 'showEditForm', value: !showEditForm}))
        if(showEditForm === false){
            let allAddedCities = item.location_permissions ? item.location_permissions[0].cities.map(item1 => {
                return {name: item1.city, city_id: item1.city_id, province_id: 1}
            }) : [];
            setEditState({...editState, addedCities: allAddedCities})

            let permission = item.permissions;
            let allPermissions = [permission.can_add_nomad ? 'addNomad' : '', permission.can_edit_nomad ? 'editNomad' : '', permission.can_delete_nomad ? 'delNomad' : '',
            permission.can_see_reports ? 'seeingReport' : '', permission.can_export_excel ? 'getExcel' : '', permission.can_add_driver ? 'addDriver' : '',
            permission.can_edit_driver ? 'editDriver' : '', permission.can_delete_driver ? 'delDriver' : '', permission.can_reject_tanker_request ? 'rejectReq' : '',
            permission.can_delete_tanker_request ? 'delReq' : '', permission.can_confirm_tanker_request_arrival ? 'manualDeliver' : '', permission.can_add_manual_tanker_request ? 'addWaterReq' : ''];

            setEditFormikValues({
                tel: item.mobile, name: item.name, username: item.username, province: item.location_permissions ? item.location_permissions[0]?.name : '',
                level: allAddedCities.length > 0 ? 'کاربر' : 'مدیر کل', checked: allPermissions
            })
        }
    }
    const handleClosePopup = () => {
        handleShowPopUp(dispatch, showForm, showEditForm)
        dispatch(handleShowUserPasswordForm(false))
    }

    const handleSearch = (searchValue) => {
        let filteredArray = bodyArray.filter(item => {
            // eslint-disable-next-line
            return item.some(value => {
                if(typeof value === 'string' && PersianToEnglish(value).includes(searchValue)){
                    return true
                }
                else if(typeof value === 'object' && value.type === 'select'){
                    if(value.props.children.find(child => child.props.children.includes(searchValue))){
                        return true
                    }
                }
            })
        })
        if(filteredArray.length === 0){
            setSearchedBodyArray(['موردی یافت نشد'])
        }
        else {
            setSearchedBodyArray(filteredArray)
        }
    }

    const handleSubmit = (newPass) => {
        const data = {
            user_id: selectedUser.userId,
            new_password: newPass
        }
        dispatch(postUserPasswordForm({data, dispatch}))
    }

    useEffect(() => {
        dispatch(getUsers(dispatch))
        dispatch(callApiAgain(false))
        // eslint-disable-next-line
    }, [callApi])

    useEffect(() => {
        if(selectedUserFromStore.obj !== null){
            if(selectedUserFromStore.type === 'showEditForm'){
                handleShowEditForm(selectedUserFromStore.obj)
            }
            else if(selectedUserFromStore.type === 'showPasswordForm'){
                handleShowPasswordForm(selectedUserFromStore.obj)
            }
            dispatch(setUserInfo({obj: null, type: ''}))
        }
        // eslint-disable-next-line
    }, [selectedUserFromStore])

    return(
        <div className='user-box'>
            <MyContext.Provider value={{showEditForm, handleShowForm: handleShowEditForm, formTitle: 'ویرایش کاربر', initialState: editState, initialInputState: editFormikValues, registerBtn: 'ویرایش', userId}}>
                <AddUserBox formComponent={AddUserForm} />
            </MyContext.Provider>
            <UserSectionMenu buttonText='افزودن کاربر' formTitle='تعریف کاربر جدید' formComponent={AddUserForm} initialState={initialState} initialInputState={initialInputState} handleSearch={handleSearch} />
            <MyContext.Provider value={{headArray, bodyArray, searchedBodyArray, title: 'مشخصات کاربران ثبت شده'}}>
                <UserInformation />
            </MyContext.Provider>
            <div className={`${(showEditForm || showUserPasswordForm) && 'show-dark-background'} dark-background`} onClick={handleClosePopup}></div>
            <MyContext.Provider value={{showUserPasswordForm, handleShowForm: handleShowPasswordForm, handleSubmit, data, initialPasswords, initialShowPass, selectedUser}}>
                <PasswordChangeBox />
            </MyContext.Provider>
        </div>
    )
}

export default UsersManagement